import { useState } from 'react';
import { useInterval } from './useInterval';

/** The current time (epoch ms), renewed every `ms` while the tab is visible: estimates that follow the clock. */
export function useNow(ms: number) {
  const [now, setNow] = useState(() => Date.now());
  useInterval(ms, () => setNow(Date.now()));
  return now;
}
